import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Col, Row, Card, UncontrolledPopover, PopoverBody, Nav, NavItem, NavLink } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
  fetchHrmsGradeControl,
  updateGradeControlStatus,
} from "../../../services/Hrms/hrms"
import capitalizeFirstLetter from "../../../utils/capitalizeFirstLetter"
import LedgerFilter from "./filter"
import {
  deleteledger,
  fetchFinanceLedgerSearch,
} from "../../../services/finance/finance"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import NumberFormat from "../../../utils/numberFormat"
import LogoutPopup from "../../../components/VerticalLayout/logoutpopup"
import { useDispatch } from "react-redux"
import { setFilter, removeFilter } from "../../../store/storeFilter/filterAction"

const LedgerFinance = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Ledger${companyname ? ` | ${companyname}` : "MEP -Hub"}`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const dispatch = useDispatch()

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)
  console.log("filtersdata", filters, filterLoading, filterError)

  const crumb = localStorage.getItem("tagLine") || "";

  const groups_id = localStorage.getItem("groups_id")
  const searchs_text = localStorage.getItem("searchs_text")
  const finalGroups = groups_id ? JSON.parse(groups_id) : ""

  console.log("checklocalstore", finalGroups?.value, searchs_text)

  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(0)
  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [country, setCountry] = useState("")
  const [group, setGroup] = useState("")
  const [page, setPage] = useState(1)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [logoutModal, setLogoutModal] = useState(false)
  const [deleteId, setDeleteId] = useState("")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [groupsData, setGroupsData] = useState(null)
  const [searchedText, setSearchedText] = useState("")
  // Ledgers vs Subledgers — subledgers are a costing dimension and used to be mixed into the
  // same list; the tab maps straight to the API's is_subledger filter.
  // saving from the form returns here on the tab the record belongs to
  const openTabFromState = useLocation()?.state?.openTab
  const [ledgerTab, setLedgerTab] = useState(
    openTabFromState === "subledgers" ? "subledgers" : "ledgers"
  )
  const isSubledgerTab = ledgerTab === "subledgers"

  // useEffect(() => {
  //   if (group_id || search_text) {
  //     setGroup(group_id ? group_id?.value : "")
  //     setSearch(search_text ? search_text : "")
  //     setGroupsData(group_id ? group_id : null)
  //     setSearchedText(search_text ? search_text : "")
  //     setPage(1)
  //     setDataPerPage(25)
  //   }
  // }, [])

  useEffect(() => {
    const fetchInitialData = async () => {
      if (filters?.groups || filters?.search) {
        // setGroup(group_id ? group_id?.value : "");
        // setSearch(search_text ? search_text : "");
        setGroupsData(filters?.groups ? filters?.groups : null);
        setSearchedText(filters?.search ? filters?.search : "");

        // Call API directly with the URL parameters
        const response = await fetchFinanceLedgerSearch({
          params: `&searchText=${filters?.search ? filters?.search : ""}${filters?.groups ? `&account_group_id=${filters?.groups?.value ? filters?.groups?.value : ""}` : ""
            }${`&sortOrder=asc`}${`&page=1&sizePerPage=25`}${`&hide_stock_in_hand=true`}${`&is_subledger=${isSubledgerTab ? 1 : 0}`}`,
        });

        const newData = response?.data?.data || [];

        setClassData(prev =>
          page > 1 && prev
            ? {
              ...response,
              data: {
                ...response.data,
                data: [...(prev.data?.data || []), ...newData],
              },
            }
            : response
        );
        setIsLoadingNextPage(response == undefined ? true : false)
        isLoadingRef.current = false;
        // setPage(1);
        // setDataPerPage(25);
      }
    };

    fetchInitialData();
  }, [filters?.groups, filters?.search, isSubledgerTab]);

  const handleActivate = item => {
    const updateStatus = async item => {
      const response = await updateGradeControlStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    }
    updateStatus(item)
  }

  const handleDelete = item => {
    const deleteLedger = async item => {
      try {
        const response = await deleteledger(item)
        toastSuccess(response?.message)
        setRefresh(refresh + 1)
      } catch (err) {
        toastError(err?.message)
      }
    }
    deleteLedger(item)
  }

  console.log(`loggedUser`, loggedUser)

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handilRest = () => {
    setRefresh(refresh + 1)
    setPage(1)
    setDataPerPage(25)
  }

  const baseColumns = [
    {
      label: "Ledger Name",
      renderCell: item => {
        return (
          <div
            onClick={() => {
              navigate(`/finance-ledger-acc`, {
                state: {
                  item,
                  bread: crumb,
                }
              })
              dispatch(setFilter({
                groups: groupsData,
                search: search
              }))
            }
            }
            className="pointer fw-bold d-flex align-items-center"
          >
            {item?.name ? capitalizeFirstLetter(item?.name) : "-"}
            {/* redundant on the Subledgers tab, where every row is one */}
            {!isSubledgerTab && Number(item?.is_subledger) === 1 && (
              <span
                className="badge ms-2 d-inline-flex align-items-center"
                style={{ background: "var(--menu-avtive, #e4edff)", color: "var(--accent-clr, #2f57c4)", fontWeight: 600 }}
                title="Subledger"
              >
                <i className="uil-layer-group me-1" style={{ fontSize: 12 }} />Subledger
              </span>
            )}
          </div>
        )
      },
    },
    {
      label: <div className="text-end pe-5">Opening Balance</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.opening_balance),
            desimalrange,
            desimalrange
          )}{" "}
          {item?.balance_type == "debit" ? "Dr" : "Cr"}
        </div>
      ),
    },
    // {
    //   label: "Status",
    //   renderCell: item => (
    //     <div>
    //       <span
    //         className={`font-13 ${
    //           item?.status == 1 ? "status-active" : "status-inactive"
    //         }`}
    //       >
    //         {item?.status == 1 ? "Active" : "Inactive"}
    //       </span>
    //     </div>
    //   ),
    // },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {loggedUser?.permission?.some(
                permissionItem => permissionItem?.name === "ledger_edit"
              ) && (
                  <div
                    className="table-popup-content"
                    onClick={() => {
                      navigate(`/finance-ledger/edit/${item?.id}`)
                      dispatch(setFilter({
                        groups: groupsData,
                        search: search
                      }))
                    }}
                  >
                    Edit
                  </div>
                )}
              {/* Delete only for transaction-free ledgers — ledgers with journal entries
                  against them must be kept (backend destroy() enforces the same rule).
                  Gated by the ledger_delete permission (like Edit), not a hard-coded role. */}
              {loggedUser?.permission?.some(
                permissionItem => permissionItem?.name === "ledger_delete"
              ) &&
                !item?.has_transactions && (
                <div
                  className={`table-popup-content`}
                  // onClick={() => handleDelete(item?.id)}
                  onClick={e => {
                    e.preventDefault()
                    setLogoutModal(true)
                    setDeleteId(item?.id)
                  }}
                >
                  Delete
                </div>
              )}
              {/* <div
                className={`${
                  item?.status == 1 ? "popover-border" : ""
                } table-popup-content`}
                onClick={() => handleActivate(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div> */}
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  // The subledger this one nests under. Shown only on the Subledgers tab, right after the name;
  // empty means it is itself top-level (and so can be picked as someone else's parent).
  const parentColumn = {
    label: "Parent Subledger",
    renderCell: item =>
      item?.parent_subledger_name ? (
        <span>{capitalizeFirstLetter(item.parent_subledger_name)}</span>
      ) : (
        <span className="text-muted fst-italic">Top level</span>
      ),
  }

  const columns = isSubledgerTab
    ? [baseColumns[0], parentColumn, ...baseColumns.slice(1)]
    : baseColumns

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    if (filters?.groups || filters?.search) return;
    setIsLoading(true);
    const fetchClass = async () => {
      const response = await fetchFinanceLedgerSearch({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "&searchText"
          }${`&sortOrder=asc`}${country ? `&country_id=${country}` : ""}${page ? `&page=${page}` : ""
          }${group ? `&account_group_id=${group}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""
          }${`&hide_stock_in_hand=true`}${`&sortOrder=asc`}${`&is_subledger=${isSubledgerTab ? 1 : 0}`}`,
      })
      // setClassData(response)
      const newData = response?.data?.data || [];

      setClassData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
      setIsLoading(false);
    }
    fetchClass()
  }, [refresh, status, search, country, page, group, dataPerPage, isSubledgerTab])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [classData, page]);

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
    setDataPerPage(25)
  }
  const handleCountryChange = id => {
    setCountry(id)
    setPage(1)
    setDataPerPage(25)
  }
  const handleGroupChange = id => {
    setGroup(id?.value)
    setGroupsData(id)
    setPage(1)
    setDataPerPage(25)
    if (id == undefined) {
      dispatch(removeFilter());
      setGroupsData(null);
    }
  }
  const handleSearchChange = data => {
    console.log("searchdata", data);
    setSearch(data)
    setPage(1)
    setDataPerPage(25)
  }
  // switching tab restarts the infinite-scroll list, else page N of the old tab is appended
  const handleTabChange = tab => {
    if (tab === ledgerTab) return
    setLedgerTab(tab)
    setClassData(undefined)
    setPage(1)
    setDataPerPage(25)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Procurement"
              breadcrumbObject={[
                { title: "Finance", link: "/finance" },
                { title: crumb || "Master", link: "/finance" },
                { title: "Ledgers", link: "/finance-ledger" },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "ledger_create"
            ) && (
                <Link
                  to="/finance-ledger/add"
                  // adding from the Subledgers tab opens the form already marked as a subledger
                  state={{ menuLabel: crumb, isSubledger: isSubledgerTab }}
                  className={"px-2 mb-3 me-2 btn btn-primary"}
                  onClick={() => {
                    dispatch(setFilter({
                      groups: groupsData,
                      search: search
                    }));
                  }}
                >
                  {isSubledgerTab ? "+ Subledger" : "+ Ledger"}
                </Link>
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <Nav tabs className="mt-2">
              {[
                { id: "ledgers", label: "Ledgers" },
                { id: "subledgers", label: "Subledgers" },
              ].map(t => (
                <NavItem key={t.id}>
                  <NavLink
                    className={ledgerTab === t.id ? "active" : ""}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleTabChange(t.id)}
                  >
                    {t.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <LedgerFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCountryChange={handleCountryChange}
              handilGroupdata={groupsData}
              searchedText={searchedText}
              handleGroupChange={handleGroupChange}
              sampleUrl={"download/ledger.xlsx"}
              importUrl={"ledger/import"}
              // the bulk upload template is a full ledger sheet — it does not apply to subledgers
              isImport={!isSubledgerTab}
              hideGroupFilter={isSubledgerTab}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div ref={tableContainerRef}  className="table_height-responsive">
                  {/* {classData && ( */}
                    <UpdateTable
                      className="mt-5"
                      nodes={classData?.data?.data}
                      paginate={classData?.data}
                      columns={columns}
                      CurrentPage={page}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      tableWidth={isSubledgerTab ? "30% 30% 20% 20%" : "40% 40% 20%"}
                      mobileWidth={isSubledgerTab ? "30% 30% 20% 20%" : "40% 40% 20%"}
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                      skeletonLoader={isLoading}
                    />
                  {/* )} */}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <LogoutPopup
        isOpen={logoutModal}
        toggle={() => setLogoutModal(!logoutModal)}
        ledgerpop={true}
        deleteId={deleteId}
        handilRest={handilRest}
      />
    </React.Fragment>
  )
}

export default LedgerFinance
